import { useCurrency } from "../context/CurrencyContext";
import { fmtXof, fmtDate } from "../lib/api";

export function Price({ xof, className = "", showRef = true, showRate = false, testid }) {
  const { fmt, code, updatedAt } = useCurrency();
  return (
    <span className="inline-block" data-testid={testid}>
      <span className={className}>{fmt(xof)}</span>
      {showRef && code !== "XOF" && (
        <span className="mt-0.5 block font-mono text-[11px] font-normal text-slate-400">(≈ {fmtXof(xof)})</span>
      )}
      {showRate && code !== "XOF" && updatedAt && (
        <span className="block text-[10px] font-normal italic text-slate-400">
          Taux mis à jour le {fmtDate(updatedAt)} — à titre indicatif
        </span>
      )}
    </span>
  );
}
